/* global debounce */

/**
 * <cart-order-details> — Used in the cart drawer.
 * Manages PO Number, VAT Number, the Northern Ireland delivery toggle and its
 * UKIMS / EORI numbers (cart attributes) plus Order Notes (cart.note) in a
 * single debounced POST to /cart/update.js. The NI toggle reveals/clears the
 * UKIMS + EORI fields client-side.
 */
if (!customElements.get('cart-order-details')) {
  class CartOrderDetails extends HTMLElement {
    constructor() {
      super();
      this.disclosure = this.closest('details');

      if (this.disclosure && this.disclosure.matches('.cart-note-disclosure')) {
        this.cartNoteToggle = this.disclosure.querySelector('.js-show-note');
      }

      this.fetchRequestOpts = {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      };

      this.noteField = this.querySelector('[name="note"]');
      this.poField = this.querySelector('[name="attributes[PO Number]"]');
      this.vatField = this.querySelector('[name="attributes[VAT Number]"]');
      this.niToggle = this.querySelector('.js-ni-delivery-toggle');
      this.niFields = this.querySelector('.cart-order-details__ni-fields');
      this.ukimsField = this.querySelector('[name="attributes[UKIMS Number]"]');
      this.eoriField = this.querySelector('[name="attributes[EORI Number]"]');

      this.init();
    }

    init() {
      this.debouncedSave = debounce(this.save.bind(this), 300);
      this.addEventListener('input', this.debouncedSave);

      if (this.niToggle) {
        this.niToggle.addEventListener('change', this.onNiToggle.bind(this));
      }
    }

    onNiToggle() {
      const active = this.niToggle.checked;
      if (this.niFields) this.niFields.hidden = !active;

      // Clear the customs fields when NI delivery is turned off so we don't
      // persist stale UKIMS / EORI values on the cart.
      if (!active) {
        if (this.ukimsField) this.ukimsField.value = '';
        if (this.eoriField) this.eoriField.value = '';
      }

      this.debouncedSave();
    }

    hasValues() {
      return (this.noteField && this.noteField.value.trim() !== '')
        || (this.poField && this.poField.value.trim() !== '')
        || (this.vatField && this.vatField.value.trim() !== '')
        || (this.niToggle && this.niToggle.checked)
        || (this.ukimsField && this.ukimsField.value.trim() !== '')
        || (this.eoriField && this.eoriField.value.trim() !== '');
    }

    save() {
      if (this.cartNoteToggle) {
        const label = this.hasValues() ? theme.strings.editCartNote : theme.strings.addCartNote;
        if (this.cartNoteToggle.textContent !== label) this.cartNoteToggle.textContent = label;
      }

      const attributes = {
        'PO Number': this.poField ? this.poField.value : '',
        'VAT Number': this.vatField ? this.vatField.value : ''
      };

      if (this.niToggle) {
        const niActive = this.niToggle.checked;
        attributes['NI Delivery'] = niActive ? 'true' : '';
        attributes['UKIMS Number'] = niActive && this.ukimsField ? this.ukimsField.value : '';
        attributes['EORI Number'] = niActive && this.eoriField ? this.eoriField.value : '';
      }

      const body = { attributes };

      if (this.noteField) {
        body.note = this.noteField.value;
      }

      this.fetchRequestOpts.body = JSON.stringify(body);
      fetch(theme.routes.cartUpdate, this.fetchRequestOpts);
    }
  }

  customElements.define('cart-order-details', CartOrderDetails);
}
